import React, { Fragment } from 'react';

import AlertBox from '../../components/AlertBox';
import Spacer from '../../components/Spacer';
import { ScreenComponent } from '../../models/ScreenComponent';
import { defaultScreenComponentPlugins } from '../study/screen-components/plugins/default';

const DynamicScreenComponentView: React.FC<{
  components: ScreenComponent<any>[];
}> = ({ components }) => {
  return (
    <Fragment>
      {components?.map(component => {
        const plugin = defaultScreenComponentPlugins.find(
          p => p.type === component.type
        );

        return (
          <Fragment key={component.id}>
            {plugin?.component ? (
              <plugin.component
                component={component}
                {...(component.props || {})}
              />
            ) : (
              <AlertBox severity='error' key={component.id}>
                &quot;{component.name || component.type}&quot; component not
                found.
              </AlertBox>
            )}
            <Spacer size={2} />
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default DynamicScreenComponentView;
